import {
  Icon,
  ModeBarButton,
  ModeBarDefaultButtons,
} from "plotly.js/dist/plotly-myPlotly.js";
import { ChartDataType, COREChartProps } from "../COREChart";
import { drawImageIntoCanvas } from "../COREChartLegend";
import { canExportCsv, downloadCSVFile } from "./csvUtils";

export const createCustomModebar = (
  data: Partial<ChartDataType>[],
  downloadCsv?: COREChartProps["downloadCsv"],
  downloadPng?: COREChartProps["downloadPng"],
  downloadPngCanvas?: COREChartProps["downloadPngCanvas"],
  plotRef?: COREChartProps["plotRef"],
  legendRef?: COREChartProps["legendRef"],
  titleRef?: COREChartProps["titleRef"],
  chartTitle?: COREChartProps["chartTitle"]
) => {
  const downloadCSVIcon: Icon = {
    width: 612,
    height: 612,
    path: "M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z",
    transform: "matrix(1 0 0 1 0 1)",
  };

  const downloadImageIcon: Icon = {
    width: 612,
    height: 612,
    path: "M194.6 32H317.4C338.1 32 356.4 45.22 362.9 64.82L373.3 96H448C483.3 96 512 124.7 512 160V416C512 451.3 483.3 480 448 480H64C28.65 480 0 451.3 0 416V160C0 124.7 28.65 96 64 96H138.7L149.1 64.82C155.6 45.22 173.9 32 194.6 32H194.6zM256 384C309 384 352 341 352 288C352 234.1 309 192 256 192C202.1 192 160 234.1 160 288C160 341 202.1 384 256 384z",
    transform: "matrix(1 0 0 1 0 1)",
  };

  const toCsvButton: ModeBarButton = {
    name: "toCsv",
    title: "Download as a CSV",
    icon: downloadCSVIcon,
    click: (e) => downloadCSVFile(e),
  };

  const toImageButton: ModeBarButton = {
    name: "toImage",
    title: "Download plot as a png",
    icon: downloadImageIcon,
    click: () =>
      drawImageIntoCanvas(plotRef, titleRef, legendRef, chartTitle, true),
  };

  const customModeBarButtons: Array<ModeBarDefaultButtons[] | ModeBarButton[]> =
    [];
  if (downloadCsv !== false && canExportCsv(data)) {
    customModeBarButtons.push([toCsvButton]);
  }

  if (downloadPng !== false) {
    if (downloadPngCanvas) {
      customModeBarButtons.push([toImageButton]);
    } else {
      customModeBarButtons.push(["toImage"]);
    }
  }

  return customModeBarButtons;
};
